import { jsx } from "react/jsx-runtime";
import "react";
import styled from "styled-components";
import { Image, StyledImage } from "@zillow/constellation";
import PropTypes from "prop-types";
const StyledCardImage = styled.div.withConfig({
  displayName: "CardImage__StyledCardImage",
  componentId: "sc-gva07i-0"
})(["overflow:hidden;border-top-left-radius:inherit;border-top-right-radius:inherit;&& ", "{width:100%;max-width:100%;height:auto;}"], StyledImage);
const CardImage = ({
  ...imageProps
}) => /* @__PURE__ */ jsx(StyledCardImage, { children: /* @__PURE__ */ jsx(Image, { ...imageProps }) });
CardImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
};
CardImage.defaultProps = {
  width: void 0,
  height: void 0
};
export {
  StyledCardImage,
  CardImage as default
};
